module.exports = __webpack_public_path__ + "img/loading_b.7032d94c.gif";